module.exports = __webpack_public_path__ + "static/media/1.4c70ed50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/siriventure/1.jpg
// module id = 144
// module chunks = 0